import { Component, OnInit } from '@angular/core';
import { IffShipmentSummaryService } from 'src/app/services/iff-shipment-summary/iff-shipment-summary.service';
import { Router } from '@angular/router';
import { IFFShipmentSummaryResponse } from 'src/app/shared/common-components/common-structure';
import { IffShipmentDetailsService } from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import {CommonHelpers} from "../../../shared/common-helpers";
import {map} from 'rxjs';
@Component({
    selector: 'app-sit-iff-summary',
    templateUrl: './sit-iff-summary.component.html',
    styleUrls: ['./sit-iff-summary.component.css'],
    standalone: false
})
export class SitIffSummaryComponent implements OnInit {

  constructor(private iffShipmentSummaryService: IffShipmentSummaryService, private iffShipmentDetailsService: IffShipmentDetailsService,
    private router: Router) { }

  updateSITShipmentPaginationRequestFn = this.iffShipmentSummaryService.updateSITShipmentPaginationRequest;
  SITShipmentPaginationResults$ = this.iffShipmentSummaryService.SITShipmentResults$.pipe(
    map((t: any) => {
      if (t.content !== null && t.content !== undefined && t.content.length > 0) {
        return CommonHelpers.sortAtoZ(t.content);
      }
    })
  );

  updateHHGIffShipmentDetailRequestFn = this.iffShipmentDetailsService.updateHHGIffShipmentDetailRequestFn;
  hhgIFFShipmentDetailResults$ = this.iffShipmentDetailsService.hhgIFFShipmentDetailResults$;

  ngOnInit() {
  }

  OnHHGShipmentSelected(IFFShipmentSelected: IFFShipmentSummaryResponse) {
    this.iffShipmentSummaryService.updateSelectedHHGShipmentSummary(IFFShipmentSelected);
    this.router.navigate(['/', 'hhgIffDetail'],
    { queryParams: { iffMasterId : IFFShipmentSelected.iffMasterId}});
  }

  OnDelinquencyReportSelected() {
    this.router.navigate(['/', 'sitDelinquency']);
  }
  OnSitComprehensiveReportSelected() {
    this.router.navigate(['/', 'sitComprehensiveReport']);
  }

  getHHGIffShipmentDetailsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
      {
        headerName: 'SCAC Code',
        field: 'scac',
      },
      {
        headerName: 'SCAC ',
        field: 'scacName'
      },
      {
        headerName: 'FAIC ',
        field: 'faicCode'
      },
      {
        headerName: 'Agency Bureau Name',
        field: 'agencyBureauName'
      },
      {
        headerName: 'Pro Bill Number',
        field: 'proBillNumber'
      },
      {
        headerName: 'BOL',
        field: 'bolNumber'
      },
      {
        headerName: 'GBL/CBL',
        field: 'gblcbl'
      },
      {
        headerName: 'Move Type',
        field: 'moveType'
      },
      {
        headerName: 'Pickup Date',
        field: 'pickupDate'
      },
      {
        headerName: 'Delivery Date',
        field: 'deliveryDate'
      },
      {
        headerName: 'Origin',
        field: 'originStateCode'
      },
      {
        headerName: 'Destination',
        field: 'destinationStateCode'
      },
      {
        headerName: 'Last Name',
        field: 'employeeLastName'
      },
      {
        headerName: 'Weight',
        field: 'weight'
      },
      {
        headerName: 'Miles',
        field: 'miles'
      },
      {
        headerName: 'Discount',
        field: 'discount',
        valueFormatter: this.iffShipmentSummaryService.percentageFormatter
      },
      {
        headerName: 'Gross Amount',
        field: 'grossAmount',
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      },
      {
        headerName: 'Net Amount',
        field: 'netAmount',
        valueFormatter: this.iffShipmentSummaryService.formatNumber,
        comparator: this.iffShipmentSummaryService.currencyComparator
      },
      {
        headerName: 'Pass Thr amt',
        field: 'passThruAmount',
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      },
      {
        headerName: 'Total AF',
        field: 'totalIFF',
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      }
    ];
  }

}
